if (!customElements.get('purecarnivore-product-faq')) {
  customElements.define(
    'purecarnivore-product-faq',
    class PureCarnivoreProductFaq extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-faq-tab]'));
        this.items = Array.from(this.querySelectorAll('[data-faq-category]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectCategory(tab.dataset.faqTab));
        });
      }

      selectCategory(category) {
        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.faqTab === category;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        this.items.forEach((item) => {
          const isVisible = category === 'all' || item.dataset.faqCategory === category;
          item.hidden = !isVisible;

          if (!isVisible) {
            item.removeAttribute('open');
          }
        });
      }
    }
  );
}
